// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk." + chunkId + ".1765415844235.css";
};